// extracted by mini-css-extract-plugin
module.exports = {"customIconWrapper":"AlertIcon_customIconWrapper__35PeY","icon":"AlertIcon_icon__aE4BP","slide-down":"AlertIcon_slide-down__Q_XQm","slide-up":"AlertIcon_slide-up__wSMBH"};